import { Injectable } from '@angular/core';
import {
    HttpInterceptor,
    HttpRequest,
    HttpHandler,
    HttpEvent,
    HttpErrorResponse,
    HttpContext,
    HttpContextToken
} from '@angular/common/http';
import { Observable, EMPTY, throwError } from 'rxjs';
import { catchError, finalize, switchMap, take } from 'rxjs/operators';
import { RequestCacheService } from '../services/request-cache.service';
import { LoaderService } from './loader.service';

export const SKIP_GLOBAL_LOADER = new HttpContextToken<boolean>(() => false);

export function withNoLoader(context: HttpContext = new HttpContext()): HttpContext {
    return context.set(SKIP_GLOBAL_LOADER, true);
}

@Injectable({ providedIn: 'root' })
export class LoaderInterceptor implements HttpInterceptor {
    // constructor(
    //     private loaderService: LoaderService,
    //     private requestCacheService: RequestCacheService,
    // ) {}

    // intercept(
    //     req: HttpRequest<any>,
    //     next: HttpHandler
    // ): Observable<HttpEvent<any>> {
    //     const skipLoader = req.context.get(SKIP_GLOBAL_LOADER);
    //     const requestUrl = req.url;

    //     const skipLoaderUrls = [
    //         // '/bulk_activity',
    //         '/bulk_progress',
    //         '/progress',
    //         'filter[called_from]=service',
            


    //         // 'filter[called_from]=page',
    //         // '/customers'


    //         // Customer Portal ng-select api calls to be skipped from loader
    //         // Set-up Printer
    //         'users/available_printers',

    //         // Dashboard
    //         'admin/v1/user_management/2/group_customer_mapping_list',
    //         'warehouses/get_selected_warehouses_by_customer', // Create order B2B, add kit products, add new product, stock movement details, add new purchase order, secondary filter
    //         'orders/shipping_types', // create order ashipping, create order template, create shipment, bulk upload template
    //         'dashboard/retailers', // secondary filter
    //         'dashboard/control_tower/services',

    //         // Add carrier rule
    //         'frontend/v1/carrier_rules/get_country_group',
    //         'frontend/v1/carrier_rules/get_postcode_group',
    //         'frontend/v1/carrier_rules/get_sku_group',
    //         'frontend/v1/carrier_rules/get_storage_type',
    //         'frontend/v1/carrier_rules/shipping_type',
    //         'frontend/v1/carrier_rules/get_city_group',
    //         'frontend/v1/carrier_rules/seller_marketplaces', // secondary filter
    //         'frontend/v1/carrier_rules/smp_shipping_methods', // Change priority rules
    //         'frontend/v1/carrier_rules/get_connected_warehouses',


    //         // Add shipping carrier rule
    //         'service_configuration/create_shipping_method',
    //         'service_configuration/dpd_services?filter[shipping_type_id]',

    //         // Label format
    //         'v1/masters/get_label_formats', // create ashipping template

    //         // Integrate marketplaces
    //         'v1/masters/countries', // marketplace details, Create order B2B, create ashipping template, create shipment, dpd create shipment, add new product, add new product configuration, create supplier, secondary filter

    //         // Order routing
    //         'marketplaces/marketplace_countries',

    //         // Marketplace details
    //         'marketplaces/currency',

    //         // Add Manage report
    //         'purchase_orders/report_types', // secondary filter

    //         // Create order B2B
    //         'v1/masters/currency', // create order ashipping, create order template, create shipment, dpd create shipment
    //         'carrier_rules/smp_shipping_methods?seller_marketplace_id',
    //         'frontend/v1/orders/carriers',
    //         'v1/masters/payment_modes', // create shipment, dpd create shipment
    //         'v1/masters/stock_conditions?type=b2c',
    //         'v1/masters/get_price_tag_formats', // add purchase order
    //         'orders/available_products', // return orders, add kit products, add new purchase order
    //         'orders/options?option_type=expiry_date', // return orders, add new purchase order
    //         'orders/options?option_type=number', // return orders, add new purchase order
    //         'v1/masters/custom_duty', // create shipment, dpd create shipment

    //         // creat ashipping template
    //         'frontend/v1/orders/doc_types',
    //         'products/uoms',

    //         // DPD create shipment
    //         'service_configuration/dpd_services',
    //         'orders/reason_for_exports',


    //         // order info
    //         'products/in_stock_channel_sku_with_search',

    //         // return orders
    //         'orders/return_order_types',
    //         'orders/return_reasons',
    //         'v1/masters/1/carriers',

    //         // kit products
    //         'products/get_kit_skus',

    //         // add new product
    //         'products/supplier', // add purchase order, secondary filter
    //         'products/product_category',
    //         'products/brand',
    //         'products/storage_types', // secondary filter
    //         'products/currency',

    //         // create supplier
    //         'v1/masters/states',
    //         'marketplaces/connected/get_seller_marketplaces', // secondary filter

    //         'orders/order_line_items?order_id',

    //         // ngx grid component
    //         'service_configuration/dpd_services?filter[product_type]',

    //         // secondary filter
    //         'products/marketplace_wise_count',
    //         'parcels/parcel_services',
    //         'orders/types',
    //         'orders/service_types',
    //         'orders/shipping_types?called_for=shipment',
    //         'orders/status',
    //         'orders/oms_order_counts?filter[state]=unsynced',
    //         'v1/masters/shipment_sub_status',
    //         'purchase_orders/status'
    //     ];
    //     const isServiceConfigSellerMarketplace = /service_configuration\/[^/]+\/seller_marketplaces/.test(requestUrl);
    //     const isServiceConfigGetShippingMethodsOrCarriers = /service_configuration\/[^/]+\/get_shipping_methods_or_carriers/.test(requestUrl);
    //     const isServiceConfigGetDPDProducts = /^frontend\/v1\/service_configuration\/[^\/]+\/DPD_products/.test(requestUrl);
    //     const isOrderShippingTypes = /^orders\/shipping_types\?called_for$/.test(requestUrl);
       

    //     // Order routing
    //     const isFetchWHZipcode = /^marketplaces\/[^/]+\/fetch_warehouse_zipcode$/.test(requestUrl);
    //     const isFetchWHCity = /^marketplaces\/[^/]+\/fetch_warehouse_city$/.test(requestUrl);
    //     const isGetSingleStore = /^marketplaces\/[^/]+\/details_include_logs$/.test(requestUrl);
    //     const isGetSources = /^marketplaces\/[^/]+\/areas$/.test(requestUrl);

    //     // Third party logistics
    //     const isGetReconnectShippingCarrier = /^logistics\/[^/]+\/seller_logistics_partner$/.test(requestUrl);

    //     // Secondary filter
    //     const isGetSellerMarketplaces = /^marketplaces\/[^/]+\/get_seller_marketplaces$/.test(requestUrl);

    //     if (
    //         skipLoaderUrls.some(url => requestUrl.includes(url)) || 
    //         isServiceConfigSellerMarketplace || 
    //         isServiceConfigGetShippingMethodsOrCarriers ||
    //         isServiceConfigGetDPDProducts ||
    //         isOrderShippingTypes ||
    //         isFetchWHZipcode ||
    //         isFetchWHCity ||
    //         isGetSingleStore || 
    //         isGetSources ||
    //         isGetReconnectShippingCarrier ||
    //         isGetSellerMarketplaces
    //         // removed as it skips the loader for the manage customers sub module in admoin portal
    //         // requestUrl.match(/(^|\/)customers(\/|$)/)
    //     ) {
    //         return next.handle(req);
    //     }

    //     const isAuthCall = /\/(login|refresh|logout)\b/.test(req.url);
    //     if (!isAuthCall && this.loaderService.isExpired()) {
    //         return throwError(() => new HttpErrorResponse({
    //             status: 401,
    //             statusText: 'Session expired (blocked by interceptor)',
    //             url: req.url
    //         }));
    //     }

    //     if (!isAuthCall && !skipLoader) this.loaderService.showLoader();

    //     return this.requestCacheService.getPendingRequest().pipe(
    //         take(1),
    //         switchMap((pendingUrl) => {
    //             if (pendingUrl === requestUrl) {
    //                 return EMPTY;
    //             }
    //             // Add the current request URL to the pending requests list
    //             this.requestCacheService.addRequest(requestUrl);

    //             // Proceed with the request
    //             return next.handle(req).pipe(
    //                 catchError((error) => {
    //                     // Remove the request URL from the pending requests list in case of an error
    //                     this.requestCacheService.removeRequest(requestUrl);
    //                     const looksExpired =
    //                         error?.error?.message === 'Invalid Signature' ||
    //                         error?.error?.message === 'Invalid Token' ||
    //                         error?.error?.message === 'Token Expired';

    //                     if (!isAuthCall && looksExpired) {
    //                         this.loaderService.notifyOnce(error);
    //                     }
    //                     return throwError(() => error);
    //                 }),
    //                 finalize(() => {
    //                     // Remove the request URL from the pending requests list after the request completes
    //                     this.requestCacheService.removeRequest(requestUrl);
    //                     if (!isAuthCall && !skipLoader) this.loaderService.hideLoader();
    //                 })
    //             );
    //         })
    //     );
    // }



    

    constructor(private loaderService: LoaderService) { }

    intercept(req: HttpRequest<any>, next: HttpHandler) {
        // console.log('INTERCEPTED:', req.url);
      
        if (this.shouldSkip(req.url)) {
        //   console.log('SKIPPED:', req.url);
          return next.handle(req);
        }
      
        // console.log('SHOW LOADER:', req.url);
        this.loaderService.show();
      
        return next.handle(req).pipe(
          finalize(() => {
            // console.log('HIDE LOADER:', req.url);
            this.loaderService.hide();
          })
        );
    }

    private shouldSkip(requestUrl: string): boolean {
        const SKIP_URL_REGEX: RegExp[] = [
            // ngx-translate's i18n JSON fetch fires from the AppComponent
            // constructor, before the view renders. Without this, the
            // loader's full-viewport overlay (z-index 10000, no
            // pointer-events restriction) mounts right at page load and
            // swallows the first click on anything underneath it — e.g.
            // the cookie-consent modal's Accept/Reject buttons — until the
            // translation file finishes loading and the overlay unmounts.
            /assets\/i18n\//,

            // '/bulk_activity',
            // '/bulk_progress',
            // '/progress',
            // 'filter[called_from]=service',
            


            // 'filter[called_from]=page',
            // '/customers'


            // Customer Portal ng-select api calls to be skipped from loader
            // Set-up Printer
            /users\/available_printers/,

            // Dashboard
            /admin\/v1\/user_management\/2\/group_customer_mapping_list/,
            /warehouses\/get_selected_warehouses_by_customer/, // Create order B2B, add kit products, add new product, stock movement details, add new purchase order, secondary filter
            /orders\/shipping_types$/, // create order ashipping, create order template, create shipment, bulk upload template
            /dashboard\/retailers/, // secondary filter
            /dashboard\/control_tower\/services/,

            // Add carrier rule
            /frontend\/v1\/carrier_rules\/get_country_group/,
            /frontend\/v1\/carrier_rules\/get_postcode_group/,
            /frontend\/v1\/carrier_rules\/get_sku_group/,
            /frontend\/v1\/carrier_rules\/get_storage_type/,
            /frontend\/v1\/carrier_rules\/shipping_type/,
            /frontend\/v1\/carrier_rules\/get_city_group/,
            /frontend\/v1\/carrier_rules\/seller_marketplaces/, // secondary filter
            /frontend\/v1\/carrier_rules\/smp_shipping_methods/, // Change priority rules
            /frontend\/v1\/carrier_rules\/get_connected_warehouses/,


            // Add shipping carrier rule
            /service_configuration\/create_shipping_method/,
            /service_configuration\/dpd_services\?filter\[shipping_type_id]/,

            // Label format
            /v1\/masters\/get_label_formats/, // create ashipping template

            // Integrate marketplaces
            /v1\/masters\/countries/, // marketplace details, Create order B2B, create ashipping template, create shipment, dpd create shipment, add new product, add new product configuration, create supplier, secondary filter, admin portal - Add new carrier, manage contacts, add new contact details

            // Order routing
            /marketplaces\/marketplace_countries/,

            // Marketplace details
            /marketplaces\/currency/,

            // Add Manage report
            /fulfillment_reports\/report_types/, // secondary filter

            // Create order B2B
            /v1\/masters\/currency$/, // create order ashipping, create order template, create shipment, dpd create shipment
            /carrier_rules\/smp_shipping_methods\?seller_marketplace_id/,
            /frontend\/v1\/orders\/carriers/,
            /v1\/masters\/payment_modes/, // create shipment, dpd create shipment
            /v1\/masters\/stock_conditions\?type=b2c/,
            /v1\/masters\/get_price_tag_formats/, // add purchase order
            /orders\/available_products/, // return orders, add kit products, add new purchase order
            /orders\/options\?option_type=expiry_date/, // return orders, add new purchase order
            /orders\/options\?option_type=number/, // return orders, add new purchase order
            /v1\/masters\/custom_duty/, // create shipment, dpd create shipment

            // creat ashipping template
            /frontend\/v1\/orders\/doc_types/,
            /products\/uoms/,

            // DPD create shipment
            /service_configuration\/dpd_services/,
            /orders\/reason_for_exports/,


            // order info
            /products\/in_stock_channel_sku_with_search/,

            // return orders
            /orders\/return_order_types/,
            /orders\/return_reasons/,
            /v1\/masters\/1\/carriers/,

            // kit products
            /products\/get_kit_skus/,

            // Product listing grids (ngx-grid) — parallel / lazy batching uses many GETs;
            // global overlay blocks the page; grids use skeleton rows + local state instead.
            // /products\/(all|in-stock|low-in-stock|out-of-stock|archived|deactivated)\/product(\?|$)/,

            // add new product
            /products\/supplier/, // add purchase order, secondary filter
            /products\/product_category/,
            /products\/brand/,
            /products\/storage_types/, // secondary filter
            /products\/currency/,

            // create supplier
            /v1\/masters\/states/, // manage contacts, add new contact details
            /marketplaces\/connected\/get_seller_marketplaces/, // secondary filter
            /marketplaces\/disconnected\/get_seller_marketplaces/, // secondary filter

            /orders\/order_line_items\?order_id/,

            // ngx grid component
            /service_configuration\/dpd_services\?filter\[product_type]/,

            // secondary filter
            /products\/marketplace_wise_count/,
            /parcels\/parcel_services/,
            /orders\/types/,
            /orders\/service_types/,
            /orders\/shipping_types\?called_for=shipment/,
            /orders\/status/,
            /orders\/oms_order_counts\?filter\[state]=unsynced/,
            /v1\/masters\/shipment_sub_status/,
            /purchase_orders\/status/,
            /marketplaces\/[^/]+\/get_seller_marketplaces\?filter\[called_from]=service/,


            /service_configuration\/[^/]+\/seller_marketplaces/,
            /service_configuration\/[^/]+\/get_shipping_methods_or_carriers/,
            /frontend\/v1\/service_configuration\/[^\/]+\/DPD_products/,
            /orders\/shipping_types\?called_for$/,


            // Order routing
            /marketplaces\/[^/]+\/fetch_warehouse_zipcode$/,
            /marketplaces\/[^/]+\/fetch_warehouse_city$/,
            /marketplaces\/[^/]+\/details_include_logs$/,
            /marketplaces\/[^/]+\/areas$/,

            // Third party logistics
            /logistics\/[^/]+\/seller_logistics_partner$/,







            // Admin Portal ng-select api calls to be skipped from loader
            // Add new carrier
            /v1\/masters\/shipping_types/,
            /carriers\/logistics_partners/,
            /carriers\/label_size/,
            /carriers\/shipping_label_type/,

            // Manage configurations
            /configurations\/field_values\?field_id=/,

            // Manage contacts
            /crm\/get_crm_customers\?filter\[crm_id]=/,
            /v1\/masters\/cities/,

            // Manage Configurations
            /configurations\/field_values\?field_id=/,
            /carriers\/carrier\?filter\[search_pattern]\[0]=/,
            /carriers\/[^/]+\/carrier_configuration_details$/,
            
            // Customer details
            /user_management\/2\/group_customer_mapping_list\?filter\[user_type]=account_manager/,
            /user_management\/2\/group_customer_mapping_list\?filter\[account_manager_user_id]/,
            /user_management\/get_user_details\/[^/]+/,

            // Store configurations
            /carriers\/[^/]+\/seller_marketplaces/,
            /carriers\/[^/]+\/get_shipping_methods_or_carriers\?seller_marketplace_id=([^&]+)&carrier_type=([^&]+)/,
            /carriers\/[^/]+\/shipping_type\?marketplace_id=([^&]+)/,
            /carriers\/[^/]+\/get_seller_logistics_partners\?shipping_method_id=([^&]+)/,
            /carriers\/[^/]+\/get_delivery_service_types\?seller_logistics_partner_id=([^&]+)/,

            // Dashboard
            /customers\/2\/customer\?page\[number]=/, // add edit user assignment
            
            // advance filter
            /orders\/status/,
            /v1\/masters\/shipment_sub_status/,
            /orders\/types/,

            // grid dropdown
            /orders\/order_substatuses_growmore/,

            // carrier rules
            /carrier_rules\/bulk_import_versions/,

            //bulk upload progress
            /bulk_progress/,
            /bulk_activity/,
            /progress/,


            // admin dashboard portal
            /customers\/2\/customer/,
            /dashboard\/product_availability/,
            /dashboard\/platform_and_services/,
            /customers\/counts/,
            /dashboard\/order_processed/,
            /dashboard\/inventory_count/,
            /dashboard\/delivery_by_countries/,
            /dashboard\/product_availability/,
            /dashboard\/customers_by_activities/,
            /dashboard\/shipment_by_status/,
            /dashboard\/total_return_orders/,
            /masters\/shipping_types/,

          // Order Bulk activities
          /orders\/counts/,
          /orders\/marketplace_counts_v1/,
          /orders\/problem_order_counts/,
          
        ];

        return SKIP_URL_REGEX.some(regex => regex.test(requestUrl));
    }
}
